// HACK: extends the default model class

var bookshelf = require("./index");
var uuid = require("uuid");

var complexDBFunctions = require("./complex-functions").default;

// NOTE: sync table model will use the default model class instead of the extended one
var sync = require("./sync").default;

var dates = require("./dates").default;

var modelPrototype = bookshelf.Model.prototype;
bookshelf.Model = bookshelf.Model.extend({
  // ???: will apply only for the models that don't have an initialize funtion declared in them
  initialize(attrs, options) {
    modelPrototype.initialize.call(this);

    this.on("creating", (model, attrs, options) => {
      // NOTE: set created (+ updated [mimic @gedmo:Timestampable])
      if (this.entityTimestampable && !options.ignoreEntityTimestampable) {
        model.set("created", dates.get_now_utc());
        model.set("updated", dates.get_now_utc());
      }

      // NOTE: set uuid
      if (this.entityUuid && !attrs.id) {
        model.set("id", uuid.v4());
      }
    });

    this.on("updating", (model, attrs, options) => {
      if (this.entityTimestampable && options.isUpdate && !options.ignoreEntityTimestampable) {
        model.set("updated", dates.get_now_utc());
      }
      if (this.entityTimestampable && options.isDelete && !options.ignoreEntityTimestampable) {
        model.set("deleted", dates.get_now_utc());
      }
    });

    this.on("created", (model, options) => {
      // NOTE: if building owner, check and create mandates for building's active meetings ..
      if (options.query._single.table == "building_owner" && options.ignoreEntitySync !== true) {
        var buildingOwner = model.attributes;
        complexDBFunctions.createMandatesForBuildingOwner(buildingOwner);
      }

      // NOTE: if meeting, check and create mandates for building's building owners ..
      if (options.query._single.table == "meeting" && options.ignoreEntitySync !== true) {
        var meeting = model.attributes;
        complexDBFunctions.createMandatesForMeeting(meeting);
      }
    });

    this.on("saved", (model, options) => {
      if (this.entitySync && !options.ignoreEntitySync) {
        var rowUuid = model.serialize().id;
        var entityName = this.entityName;
        sync.insertOrUpdateInSyncTable(rowUuid, entityName);
      }
    });

    this.on("destroyed", (model, options) => {
      if (this.entitySync && !options.ignoreEntitySync) {
        var rowUuid = model.previousAttributes().id;
        var entityName = this.entityName;
        sync.insertOrUpdateInSyncTable(rowUuid, entityName);
      }
    });

    // !!!: FIXME: do cascade delete functionality here .. add params, options in entities and use them

    // ???: check deleted from here?
    /**
    this.on("fetching:collection", function (model, columns, options) {
      options.query.where("deleted", null);
    });
    this.on("fetching", function (model, columns, options) {
      options.query.where("deleted", null);
    });
    */

    // EX: cascade delete from buildings
    /**
    this.on("updated", (model, options) => {
 // console.log("model updated building", model);
      if (model.get("deleted") !== null) {
   // console.log("is deleted BUILDING");
        // ???: TODO: error handling
        // TODO: deep CASCADE DELETE

        // NOTE: through loop
        BuildingOwnerDB.where(qb => qb.where("building_id", model.get("id")).whereNull("deleted"))
          .fetchAll()
          .then(res => {
       // console.log("b owners", res);
            res.models.forEach(model => {
              model
                .save({ deleted: "test cascade soft delete" }, { method: "update", patch: true })
                .then(res => {
             // console.log(res);
                });
            });
          });

        // NOTE: doesn't work as expected ... through one query
        // BuildingOwnerDB.where(qb => qb.where("building_id", model.get("id")).whereNull("deleted"))
        //   .collection()
        //   .save(
        //     { deleted: "test cascade soft delete" },
        //     {
        //       method: "update",
        //       patch: true,
        //     }
        //   )
        //   .then(res => {
        //// console.log(res);
        //   })
        //   .catch(err => {
        // console.log(err);
        //   });
      }
    });
    */

    // EX: cascade delete from b owners
    /**
    this.on("updated", (model, options) => {
      if (model.get("deleted") !== null) {
   // console.log("is deleted BUILDING OWNER");
        // ???: TODO: error handling
        // TODO: deep CASCADE DELETE

        // ... delete mandates
        // NOTE: see code in Building "updated" event handler
      }
    });
    */
  },
});

module.exports = bookshelf;
